import { render, staticRenderFns } from "./SaleGoals.vue?vue&type=template&id=50fd348b"
import script from "./SaleGoals.vue?vue&type=script&lang=js"
export * from "./SaleGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports